import GATSBY_COMPILED_MDX from "/home/runner/work/capsulecrm.com/capsulecrm.com/src/mdxPages/one-off/deletion/index.es.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import MainLayout from "@/layouts/MainLayout";
import MDXContentWrapper from "@/components/MDXContentWrapper";
import CenteredHero from "@/components/CenteredHero";
import {Link} from "@zestia/gatsby-plugin-react-i18next";
import SharedHead from "@/components/SharedHead";
import Longform from "@/components/Longform";
import findImage from "@/utils/find-image";
import IntegrationsShowcase from "@/components/IntegrationsShowcase";
import {gtmTracking} from "@/utils/gtm-tracking";
export const Head = props => {
  const {data} = props;
  return React.createElement(SharedHead, Object.assign({}, props, {
    title: data.mdx.frontmatter.title,
    description: data.mdx.frontmatter.summary
  }));
};
function OneOffLayout({data, children}) {
  const overrides = {
    IntegrationsHighlight: props => {
      return React.createElement(IntegrationsShowcase, {
        title: props.title || "Integrate with the tools you already use",
        description: props.description || "Get more done in a day by connecting Capsule to all your favorite software - giving you one complete view of your customer."
      });
    },
    Link: props => {
      if (props.to === "/signup/" || props.to === "/signup/") {
        return React.createElement(Link, Object.assign({}, props, {
          onClick: () => gtmTracking("CTA Click", "Try Free", "")()
        }));
      }
      return React.createElement(Link, props);
    }
  };
  return React.createElement(MainLayout, {
    trackingData: {
      intent: data.mdx.frontmatter.intent
    }
  }, React.createElement(CenteredHero, {
    centered: "true",
    title: data.mdx.frontmatter.header_title ?? data.mdx.frontmatter.title,
    backgroundClass: data.mdx.frontmatter.header_class ? data.mdx.frontmatter.header_class : "",
    wrapperClass: "col-sm-9 col-md-7 col-lg-8",
    showButton: data.mdx.frontmatter.show_signup_button?.toString(),
    buttonText: data.mdx.frontmatter.signup_button_text,
    buttonClass: "btn btn--lg ",
    text: data.mdx.frontmatter.header_description ?? data.mdx.frontmatter.summary,
    headerImage: data.mdx.frontmatter.header_image && findImage(data.allFile, data.mdx.frontmatter.header_image)
  }), React.createElement("div", {
    className: "container-fluid"
  }, React.createElement("section", {
    className: `col-xs-12 ${!data.mdx.frontmatter.full_width ? "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2" : ""}`
  }, React.createElement(MDXContentWrapper, {
    overrides: overrides
  }, React.createElement(Longform, null, children)))));
}
export const query = graphql`
  query ($language: String, $id: String!) {
    ...Locales
    ...Integrations
    allFile(filter: { relativeDirectory: { eq: "standalone" } }) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        summary
        header_title
        header_description
        header_image
        header_class
        show_signup_button
        signup_button_text
        full_width
        intent
      }
      body
      id
    }
  }
`;
OneOffLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(OneOffLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
